import React from 'react';
import './FaqPage.css';

import { PageTitle, Faqs } from '../../../components';
import { faqsContent, images } from '../../../constants';



const FaqPage = () => { 

  return (
    <> 
      {/* Page title */}
      <PageTitle title={'faqs'} page={'faqs'} />

      <section className='faq-page'>

        {/* Faq Accordion container */}
        <Faqs faqs={faqsContent} />

        {/* Faq Image */}
        <div className='image'>
          <img src={images.FAQs} alt='FAQs-Pic' /> 
        </div>
        
      </section>
    </>
  );
};

export default FaqPage;